/**
 * - The videos_data file uses a similar format to the vitals_data file
 * - for compatibility with the VitalsOverlay component.
 * - Unlike the vitals_data file, the videos_data view in the VitalsOverlay
 * - should only require static data and not require any dyanmicly generated data.
 */

const VIDEOS = [
	{
		value: ' أول أكسيد الكربون - AIRS',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'تُظهر هذه الرسوم المتحركة وفرة أول أكسيد الكربون في جميع أنحاء العالم في 2015-2016 ، ويوضح بشكل خاص تأثير الحرائق المتعمدة من الزراعة "المائلة والحروق".',
		sphereMapThumbSrc: 'AIRS_CO.png',
		datasetGroups: [
			{
				title: ' أول أكسيد الكربون - AIRS',
				src: 'assets/video/CO_Palm_Oil.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'تُظهر هذه الرسوم المتحركة الوفرة اليومية في أجزاء لكل مليار من أول أكسيد الكربون (CO) من يونيو 2015 حتى أبريل من عام 2016. يتم إنشاء أول أكسيد الكربون عن طريق الاحتراق ، مثل حرائق الغابات ، أو عادم محركات الاحتراق الداخلي ، أو عن طريق حرق الخشب أو الفحم أو الغاز الطبيعي.في هذه الفترة الزمنية ، يمكنك أن ترى نتيجة أحداث "القطع والحرق" واسعة النطاق ، حيث تحترق العديد من الدول وتطهير غاباتها من أجل زراعة المحاصيل القابلة للحياة اقتصاديًا.هذا واضح بشكل خاص في غابات الأمازون المطيرة وإندونيسيا ووسط إفريقيا.',
				sphereMapThumbSrc: 'AIRS_CO.png',
				dateRange: 'يونيو 2015 - أبريل 2016',
				mobileDateRange: '06/2015 - 04/2016',
				related: ['carbon_monoxide'],
				colorBarSrc: ['mono_bar.png']
			}
		]
	},
	{
		value: ' درجة حرارة الهواء السطحي - AIRS',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'تُظهر هذه الرسوم المتحركة حدث "الدوامة القطبية" في عام 2014 الذي أدى إلى انخفاض درجات الحرارة إلى أسفل الساحل الشرقي للولايات المتحدة.',
		sphereMapThumbSrc: 'AIRS_Temp_Surface.png',
		datasetGroups: [
			{
				title: ' درجة حرارة الهواء السطحي - AIRS',
				src: 'assets/video/Polar_Vortex.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'يشير الخط الأزرق إلى خط التجمد ، حيث تكون درجة الحرارة بالضبط 32 درجة فهرنهايت (0 درجة مئوية) ، ودرجات الحرارة الأخرى مشفرة بالألوان وفقًا للأسطورة.يُنظر إلى الخط الأزرق وهو ينزلق تحت الأشرطة المتوسطة في أمريكا الشمالية ، بسبب حدث دوامة قطبية قوية حدث في أوائل عام 2014. تسبب هذا في درجات حرارة منخفضة بشكل غير عادي امتدت إلى أسفل الساحل الشرقي للولايات المتحدة.دوامة القطبية القطبية هي مجموعة قوية من الرياح في الستراتوسفير المحيطة بالقطب الشمالي.في حوالي كل عام ، تضعف الرياح ويمكن أن تعطل تيار الطائرات القطبية السفلى ، مما يجعلها "جذابة" وتسمح لدرجات الحرارة الباردة بالتحرك إلى أبعد من الجنوب.',
				sphereMapThumbSrc: 'AIRS_Temp_Surface.png',
				dateRange: 'ديسمبر 2013 - أبريل 2014',
				mobileDateRange: '12/2013 - 04/2014',
				related: ['air_temperature'],
				colorBarSrc: ['surfaceDayTemp_bar.png', 'surfaceDayTemp_C_bar.png']
			}
		]
	},
	{
		value: 'ثاني اكسيد الكربون منذ عام 2002',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		description: 'تُظهر هذه الرسوم المتحركة مستوى ثاني أكسيد الكربون (CO₂) في أجزاء لكل مليون بين سبتمبر من عام 2002 حتى فبراير من عام 2016 ، باستخدام بيانات من أداة AIRS على مركبة الفضاء Aqua.إذا كان مستوى CO₂ هو 400 جزء لكل مليون ، فهذا يعني أنه إذا قمت بجذب علبة من الهواء بمليون جزيء فيه ، فسيكون 400 منهم CO₂.سيكون معظمهم النيتروجين (78 ٪) والأكسجين (21 ٪) ، مع وجود طن من الغازات الأخرى.الغازات المعروفة باسم "غازات الدفيئة" ، مثل CO₂ والميثان وأكسيد النيتروز وبخار الماء ، هي مجرد 0.1 ٪ من الغازات الجوية ولكن لها تأثير قوي للغاية على توازن الطاقة في الغلاف الجوي.تحرص غازات الدفيئة الحرارة داخل الغلاف الجوي ، مما يمنعها من الإشعاع إلى الفضاء ، مما يعطل توازن تبادل الطاقة.على مدار 800000 عام ، حتى عام 1950 ، لم تتجاوز الأجزاء لكل مليون من CO₂ 300. مع ظهور هذه البيانات ، لقد ذهبنا من حوالي 370 جزء في المليون في عام 2002 إلى حوالي 405 جزء في المليون في عام 2016. في عام 2022 ، كان متوسط CO₂ لهذا العام417 جزء في المليون.',
		shortDescription: 'تُظهر هذه الرسوم المتحركة نموًا ثابتًا لوفرة ثاني أكسيد الكربون العالمية من 2002-2016.',
		sphereMapThumbSrc: 'AIRS_CO2.png',
		datasetGroups: [
			{
				title: 'ثاني اكسيد الكربون منذ عام 2002',
				src: 'assets/video/CO2.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'تُظهر هذه الرسوم المتحركة مستوى ثاني أكسيد الكربون (CO₂) في أجزاء لكل مليون بين سبتمبر 2002 حتى فبراير من عام 2016 ، باستخدام بيانات من أداة AIRS على مركبة الفضاء Aqua.إذا كان مستوى CO₂ هو 400 جزء لكل مليون ، فهذا يعني أنه إذا قمت بجذب علبة من الهواء بمليون جزيء فيه ، فسيكون 400 منهم CO₂.سيكون معظمهم النيتروجين (78 ٪) والأكسجين (21 ٪) ، مع وجود طن من الغازات الأخرى.الغازات المعروفة باسم "غازات الدفيئة" ، مثل CO₂ والميثان وأكسيد النيتروز وبخار الماء ، هي مجرد 0.1 ٪ من الغازات الجوية ولكن لها تأثير قوي للغاية على توازن الطاقة في الغلاف الجوي.تحرص غازات الدفيئة الحرارة داخل الغلاف الجوي ، مما يمنعها من الإشعاع إلى الفضاء ، مما يعطل توازن تبادل الطاقة.لمدة 800000 عام ، حتى عام 1950 ، لم تتجاوز الأجزاء لكل مليون من CO₂ 300. مع ظهور هذه البيانات ، لقد ذهبنا من حوالي 370 جزء في المليون في عام 2002 إلى حوالي 405 جزء في المليون في عام 2016. في عام 2022 ، كان متوسط CO₂ لهذا العام417 جزء في المليون.',
				sphereMapThumbSrc: 'AIRS_CO2.png',
				dateRange: 'سبتمبر 2002 - فبراير 2016',
				mobileDateRange: '09/2002 - 02/2016',
				related: ['carbon_dioxide'],
				colorBarSrc: ['newCo2_bar.png']
			}
		]
	},
	{
		value: ' الرياح السطحية للمحيط - Quikscat',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'تُظهر هذه الرسوم المتحركة سرعة الرياح في المحيط والاتجاه بين أغسطس وأكتوبر 2005 ، بما في ذلك إعصار كاترينا تراجع في 29 أغسطس.',
		sphereMapThumbSrc: 'QuickSCAT.png',
		datasetGroups: [
			{
				title: ' الرياح السطحية للمحيط - Quikscat',
				src: 'assets/video/ccmp.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'تُظهر هذه الرسوم المتحركة الرياح على المحيط بين أغسطس وأكتوبر 2005. قامت مهمة Quikscat بقياس سرعة الرياح واتجاهها على المحيط الخالي من الجليد باستخدام مقياس النثر.لاحظ أنه يمكنك رؤية إعصار كاترينا وتساقط الهبوط مع نيو أورليانز في 29 أغسطس ، وكذلك مراقبة أنماط الرياح المكثفة حول منطقة القطب الجنوبي.',
				sphereMapThumbSrc: 'QuickSCAT.png',
				dateRange: 'أغسطس 2005 - أكتوبر 2005',
				mobileDateRange: '08/2005 - 10/2005',
				related: [''],
				colorBarSrc: ['ccmp.png']
			}
		]
	},
	{
		value: ' مجال الجاذبية - GRACE',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'يظهر مجال الجاذبية المتقلب من 2008-2017 في هذه الرسوم المتحركة باستخدام بيانات من مهمة Grace.',
		sphereMapThumbSrc: 'gravity_field.png',
		datasetGroups: [
			{
				title: ' مجال الجاذبية - GRACE',
				src: 'assets/video/grace.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'تُظهر هذه الرسوم المتحركة بيانات النعمة الشهرية من أكتوبر من عام 2008 حتى مايو من عام 2017. نظرًا لأن مهمة النعمة تقيس تقلبات في مجال الثقل نفسه ، يمكنك أن ترى أين تكون الجاذبية أقوى من ذي قبل (الأرجواني) وحيث تكون أضعف من ذي قبل (الأحمر (الأحمر).يتم إنشاء الجاذبية بواسطة المادة.لذلك إذا كانت الأرض "تكتسب الوزن" ، فستكون أكثر ثقلًا ، لأن قوة الجاذبية تتناسب بشكل مباشر مع الكتلة.كيف يمكن أن تكتسب الأرض الوزن؟السائق الأساسي للتغيير الكتلي على الأرض هو عن طريق حركة المياه والجليد.بمجرد فهم ذلك ، يمكنك أن ترى المواسم الممطرة تفسح المجال أمام المواسم الجافة في أماكن مثل Amazon Rainforest.لاحظ أن جزيرة غرينلاند دائمًا باللون الأحمر ، وتخسر الكتلة ، مع ذوبان الجليد وتتدفق إلى البحر.',
				sphereMapThumbSrc: 'gravity_field.png',
				dateRange: 'أكتوبر 2008 - مايو 2017',
				mobileDateRange: '10/2008 - 05/2017',
				related: ['gravity_field_map'],
				colorBarSrc: ['grace_bar.png']
			}
		]
	},
	{
		value: ' تباين مستوى سطح البحر - OSTM',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'تُظهر هذه الرسوم المتحركة مستوى سطح البحر العالمي على مدار عام 2015 ، بما في ذلك حدث قوي من النينيو والذي يمكن رؤيته في المحيط الهادئ الاستوائي.',
		sphereMapThumbSrc: 'JAS_SLV.png',
		datasetGroups: [
			{
				title: ' تباين مستوى سطح البحر - OSTM',
				src: 'assets/video/ostm.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'تعرض هذه الرسوم المتحركة بيانات مستوى سطح البحر الشهرية طوال عام 2015. هذا العام كبير ، حيث كان له حدث كبير "النينيو".النينيو هي زيادة تحدث أحيانًا في درجة حرارة سطح البحر على طول خط الاستواء في شرق وسط المحيط الهادئ إلى شرق المحيط الهادئ ، ومرئية باللون الأبيض في الرسوم المتحركة.تم قياس مهمة Jason-2 (OSTM) ارتفاع سطح المحيط ، وهو مؤشر محتمل للدفء من درجات حرارة سطح البحر المعتادة (تتوسع المياه الدافئة ، ويصبح "أطول".من درجات حرارة سطح البحر العادية) ، يمكن أن تؤثر بشكل كبير على المناخ العالمي ، مما يخلق عواصف مكثفة في بعض الأماكن والجفاف في غيرها.',
				sphereMapThumbSrc: 'JAS_SLV.png',
				dateRange: 'يناير 2015 - ديسمبر 2015',
				mobileDateRange: '01/2015 - 12/2015',
				related: ['sea_level'],
				colorBarSrc: ['trm_bar.png']
			}
		]
	},
	{
		value: 'الأنهار الجوية',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'تُظهر هذه الرسوم المتحركة الأنهار الجوية القوية التي تتشكل في جميع أنحاء العالم ، وفي ولاية كاليفورنيا بشكل خاص في يناير من عام 2017.',
		sphereMapThumbSrc: 'Atmospheric_River.png',
		datasetGroups: [
			{
				title: 'الأنهار الجوية',
				src: 'assets/video/atmo_river_dated_1080p30.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'يجمع هذا التصور بين بيانات هطول الأمطار من مهمة قياس هطول الأمطار العالمية (GPM) استردادات متعددة الأدوات (IMERG) وبيانات بخار الماء من نموذج نظام مراقبة الأرض (GEO).معا ، يسمحون للعلماء بدراسة الأنهار الجوية وهطول الأمطار الغزيرة التي يجلبونها.لاحظ أن أحداث النهر الجوي لا تحدث فقط في كاليفورنيا ، ولكن في جميع أنحاء العالم في المناطق المتوسطة.',
				sphereMapThumbSrc: 'Atmospheric_River.png',
				dateRange: '1 يناير 2017 - 14 يناير 2017',
				mobileDateRange: '01/01/2017 - 01/14/2017',
				related: [''],
				colorBarSrc: ['ar_liquid_frozen_bar.png']
			}
		]
	},
	{
		value: ' الاستجابة العالمية والعلوم - ARIA',
		title: 'الرسوم المتحركة العالمية',
		type: 'global',
		shortDescription: 'تُظهر هذه الخريطة مجالات في العالم حيث قدم مشروع ARIA المساعدة على المستوى التشغيلي لدعم مجتمعات العلوم والاستجابة للمخاطر المحلية والوطنية والدولية.',
		sphereMapThumbSrc: 'ARIA.png',
		datasetGroups: [
			{
				title: ' الاستجابة العالمية والعلوم - ARIA',
				src: 'assets/video/full_world_aria_events.mp4',
				type: 'global',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'ARIA هو تعاون بين JPL و Caltech لاستغلال الرادار والاستشعار عن بعد البصري ، GPS ، والملاحظات الزلزالية لعلوم المخاطر والاستجابة.تُظهر هذه الخريطة العالمية بعض المواقع في جميع أنحاء العالم حيث ساعد مشروع ARIA المجتمعات المحتاجة.تحقق أريا في عمليات وتأثيرات الزلازل والبراكين والانهيارات الأرضية والحرائق وحركة السوائل تحت السطحية والمخاطر الطبيعية الأخرى من خلال تطبيق الجيوديسية الحديثة ، المدمجة مع الملاحظات الأرضية ، للمساعدة في تحسين مرونة مثل هذه الأحداث.يقوم المشروع بتطوير أحدث قياسات تشوه الأرض تغيير طرق الكشف والنماذج المادية باستخدام GPS وملاحظات رادار الفتحة الاصطناعية ، وأتمتة المعالجة الواسعة النطاق المطلوبة ، وإنتاج منتجات البيانات الأساسية لمجتمع العلوم.مع نمو السكان ، أصبحت الاستجابة للكوارث الطبيعية جزءًا متزايد الأهمية من الصلة بين العلم والمجتمع.نقوم بتطوير أدوات لاستخدام الشبكات المتزايدة لأجهزة استشعار GPS القائمة على الأرض وأبراج القمر الصناعي للتصوير لمراقبة المخاطر والاستجابة لها.مع هذه الأدوات الجديدة ، نتوقع تحسين الوعي الظرفي مباشرة بعد الكوارث.',
				sphereMapThumbSrc: 'ARIA.png',
				dateRange: '',
				related: [''],
				colorBarSrc: ['']
			}
		]
	},
	{
		value: 'انهيار وادي وسط كاليفورنيا',
		title: 'فيديو جغرافي',
		type: 'geoLocated',
		shortDescription: 'تُظهر هذه الرسوم المتحركة الهبوط (الغرق) لجزء من وادي سان جواكين في وسط كاليفورنيا خلال عامي 2015 و 2016.',
		sphereMapThumbSrc: 'California_Subsidence.png',
		datasetGroups: [
			{
				title: 'انهيار وادي وسط كاليفورنيا',
				src: 'assets/video/CA_Central_Valley.mp4',
				type: 'geoLocated',
				dropDownTitle: 'الرسوم المتحركة',
				description: 'تُظهر هذه الرسوم المتحركة الإجمالي الهبوط في جزء من وادي سان جواكين بين مايو 2015 وسبتمبر 2016 كما لاحظت القمر الصناعي Sentinel-1A التابع لوكالة الفضاء الأوروبية وتحليله من قبل العلماء في JPL.تظهر مناطق الهبوط الأكثر شمولاً في ظلال الوردي.منذ عشرينيات القرن العشرين ، تسبب الضخ المفرط للمياه الجوفية في الآلاف من الآبار في تهدئة الأرض ، أو بالوعة ، بما يصل إلى 8.5 متر (28 قدمًا) في أقسام وادي سان جواكين في كاليفورنيا.يتفاقم هذا الهبوط أثناء الجفاف ، عندما يعتمد المزارعون بشدة على المياه الجوفية للحفاظ على واحدة من أكثر المناطق الزراعية إنتاجية في الولايات المتحدة.تعتبر الهبوط مصدر قلق خطير ومليء بالتحديات لمديري المياه في كاليفورنيا ، حيث يعرض القنوات الحكومية والاتحادية والسدود والجسور والطرق المعرضة لخطر الأضرار.بالفعل ، تضررت هبوط الأراضي على المدى الطويل الآلاف من آبار المياه الجوفية العامة والخاصة في جميع أنحاء وادي سان جواكين.علاوة على ذلك ، يمكن أن يقلل الهبوط بشكل دائم من سعة تخزين طبقات المياه الجوفية تحت الأرض ، مما يهدد إمدادات المياه المستقبلية.',
				sphereMapThumbSrc: 'California_Subsidence.png',
				related: ['gravity_field_map'],
				colorBarSrc: ['subsidence_bar.png'],
				dateRange: '7 مايو 2015 - 27 ديسمبر 2016',
				mobileDateRange: '05/07/2015 - 12/27/2016',
				north_boundary: 38.253,
				south_boundary: 34.727464,
				east_boundary: -118.46,
				west_boundary: -120.9983
			}
		]
	},
	{
		value: 'منحنى الانحدار',
		title: 'فيديو',
		type: 'modal',
		shortDescription: 'توضح هذه الرسوم المتحركة كيف يتقلب ثاني أكسيد الكربون مع الفصول بسبب امتصاص الغطاء النباتي ثم إطلاق CO₂ من الربيع إلى الشتاء.',
		sphereMapThumbSrc: 'keeling_curve_thumbnail.png',
		datasetGroups: [
			{
				title: 'منحنى الانحدار',
				src: 'assets/video/Keeling_Curve.mp4',
				type: 'modal',
				dropDownTitle: 'فيديو',
				description: 'منحنى الانحدار هو رسم بياني لتراكم ثاني أكسيد الكربون في جو الأرض استنادًا إلى القياسات المستمرة التي اتخذت في مرصد مونا لوا في جزيرة هاواي من عام 1958 إلى يومنا هذا.تم تسمية المنحنى باسم العالم تشارلز ديفيد كيلينج ، الذي بدأ برنامج المراقبة.خلال الخريف والشتاء في نصف الكرة الشمالي ، عندما تبدأ الأشجار والنباتات في فقدان أوراقها وتسوسها ، يتم إطلاق ثاني أكسيد الكربون في الغلاف الجوي ، ويخلط مع الانبعاثات من المصادر البشرية.هذا ، إلى جانب عدد أقل من الأشجار والنباتات التي تزيل ثاني أكسيد الكربون من الغلاف الجوي ، يسمح بالتركيزات بالتسلق في فصل الشتاء ، حيث بلغت ذروتها بحلول أوائل الربيع.خلال فصل الربيع والصيف في نصف الكرة الشمالي ، تمتص النباتات كمية كبيرة من ثاني أكسيد الكربون من خلال التمثيل الضوئي.',
				sphereMapThumbSrc: 'keeling_curve_thumbnail.png',
				related: ['carbon_dioxide']
			}
		]
	},
	{
		value: 'فقدان الجليد في جرينلاند',
		title: 'فيديو',
		type: 'modal',
		shortDescription: 'يظهر صفيحة جليدية في غرينلاند في هذه الرسوم المتحركة من 2002-2020.',
		sphereMapThumbSrc: 'Greenland_ice_loss_thumbnail.png',
		datasetGroups: [
			{
				title: 'فقدان الجليد في جرينلاند',
				src: 'assets/video/grace_monthly_anomaly_gris_black_vel_720p4.mp4',
				width: '1108px',
				height: '626px',
				type: 'modal',
				dropDownTitle: 'فيديو',
				description: 'انخفضت كتلة غرينلاند الجليدية في السنوات القليلة الماضية بسبب ذوبان السطح وحد الجليد.تشير الأبحاث القائمة على بيانات الأقمار الصناعية إلى أنه بين عامي 2002 و 2020 ، ألقى غرينلاند في المتوسط 279 مليار طن متري من الجليد سنويًا ، مما يزيد من ارتفاع مستوى سطح البحر.تُظهر هذه الصور ، التي تم إنشاؤها من بيانات Grace و Grace-FO ، تغييرات في كتلة الجليد في Greenland منذ عام 2002. تشير الظلال البرتقالية والأحمر إلى المناطق التي فقدت الكتلة الجليدية ، بينما تشير الظلال الزرقاء الفاتحة إلى المناطق التي اكتسبت الكتلة الجليدية.يشير الأبيض إلى المناطق التي لم يكن فيها تغيير ضئيل للغاية أو معدوم في كتلة الجليد منذ عام 2002. بشكل عام ، شهدت المناطق ذات الارتفاع العالي بالقرب من وسط غرينلاند القليل من التغيير ، في حين أن المناطق الساحلية المنخفضة والمناطق الساحلية أكثر من 5 أمتار (16.4 قدمًا (16.4 قدمًا) من فقدان الكتلة الجليدية (المعبر عنها في ارتفاع المياه ؛ الأحمر الداكن) خلال فترة 19 سنة.حدثت أكبر كتلة على طول ساحل غرب غرينلاند.تتزامن متوسط خطوط التدفق (الرمادي ؛ تم إنشاؤه من التداخل في رادار القمر الصناعي) من جليد غرينلاند إلى مواقع الأنهار الجليدية البارزة وتتزامن مع مناطق من أعلى خسارة في الكتلة.وهذا يدعم ملاحظات أخرى مفادها أن مياه المحيطات الاحترار حول غرينلاند تلعب دورًا رئيسيًا في فقدان الكتلة الجليدية المعاصرة.',
				sphereMapThumbSrc: 'Greenland_ice_loss_thumbnail.png',
				related: ['gravity_field_map']
			}
		]
	},
	{
		value: 'نشاط البرق العالمي',
		title: 'فيديو',
		type: 'modal',
		shortDescription: 'تُظهر هذه الرسوم المتحركة نشاط البرق الذي تم التقاطه بواسطة مستشعر تصوير البرق (LIS) التابع لمحطة الفضاء الدولية، بمتوسطات شهرية من عام 2017 إلى عام 2023.',
		sphereMapThumbSrc: 'LightningData_thumbnail.png',
		datasetGroups: [
			{
				title: 'نشاط البرق العالمي',
				src: 'assets/video/LightningData.mp4',
				width: '1108px',
				height: '626px',
				type: 'modal',
				dropDownTitle: 'فيديو',
				description: 'البرق هو ظاهرة طبيعية تنتج عن المجالات الكهربائية القوية الناتجة عن الحمل الحراري الرطب في الغلاف الجوي وعمليات هطول الأمطار النشطة. يمكن أن يكون خطيراً، لأنه يمكن أن يسبب حرائق وانقطاع التيار الكهربائي والإصابات، ولكنه يوفر أيضاً رؤى علمية مهمة، مثل تطور العواصف الرعدية، وحالة تغير المناخ على المدى الطويل، ومجموعة واسعة من المواضيع الأخرى، بدءاً من الطقس إلى فيزياء البرق. يكتشف مستشعر تصوير البرق (LIS) الموجود في محطة الفضاء الدولية (ISS) التوقيعات الضوئية العالمية للبرق، ويعمل ليلاً ونهاراً بكفاءة في الكشف عن الفلاش تبلغ حوالي 60%. توفر بياناتها البحثية بيانات البرق في الوقت الفعلي للتنبؤ وتكمل أجهزة استشعار وشبكات البرق الأخرى لتكون فعالة للاستخدام في دراسات فيزياء البرق وعلم المناخ والغلاف الجوي. تم إطلاق LIS في فبراير 2017 وبدأ في تقديم البيانات في 1 مارس 2017. وتوسع هذه البيانات السجلات العالمية إلى خطوط العرض الأعلى، في حين أنها متسقة مع الدراسات التي أجريت سابقاً. يُظهر الفيديو متوسط اكتشافات البرق لكل شهر، مع البيانات التي تم جمعها من عام 2017 إلى عام 2023. ويتم التعبير عن كثافة معدل وميض البرق بعدد ضربات البرق لكل كيلومتر مربع في السنة (km⁻² year⁻¹).',
				sphereMapThumbSrc: 'LightningData_thumbnail.png',
				related: ['']
			}
		]
	},
	{
		value: 'مستوى سطح البحر',
		title: 'رسم بياني',
		type: 'static',
		shortDescription: 'يُظهر هذا الرسم البياني صعود مستوى سطح البحر منذ عام 1992 ، إلى جانب التباين الموسمي.',
		sphereMapThumbSrc: 'sea_level_thumbnail.png',
		datasetGroups: [
			{
				title: 'مستوى سطح البحر',
				src: 'assets/images/graphics/slrtrend_tpx_2022.png',
				width: '1002px',
				height: '626px',
				type: 'static',
				dropDownTitle: 'رسم بياني',
				description: 'في هذا الرسم البياني ، ناتج عن الارتفاعات والانخفاض كل عام بسبب تبادل المياه بين الأرض والبحر.ينقل المطر الشتوي وتساقط الثلوج في نصف الكرة الشمالي المياه من المحيط إلى الأرض ، ويستغرق الأمر بعض الوقت حتى يعود هذا إلى المحيطات.يتسبب هذا التأثير عادةً في حوالي 1 سنتيمتر من الارتفاع والانخفاض كل عام ، مع أكثر أو أقل قليلاً خلال سنوات النينيو والنينيا.على الرغم من أن ارتفاع بضعة ملليمترات من ارتفاع مستوى سطح البحر في السنة قد يبدو صغيراً ، فإن العلماء يقدرون أن كل 2.5 سنتيمتر (1 بوصة) من ارتفاع مستوى سطح البحر يترجم إلى 2.5 متر (8.5 قدم) من واجهة الشاطئ المفقودة على طول الساحل المتوسط.وهذا يعني أيضًا أن المد والجزر العالية والعواصف يمكن أن ترتفع إلى أعلى ، مما يجعل المزيد من الفيضانات الساحلية ، حتى في الأيام المشمسة.في تقرير صدر في فبراير 2022 ، خلص العلماء إلى أنه بحلول عام 2050 ، قد يرتفع مستوى سطح البحر على طول السواحل الأمريكية بين 25 إلى 30 سم (من 10 إلى 12 بوصة) فوق مستويات اليوم.ما يبرز من سجل قياس الارتفاع الأقمار الصناعية هو أن الارتفاع أكثر من 30 عامًا أكبر بنسبة عشرة أضعاف من التبادل الطبيعي للمياه بين المحيط والأرض في عام واحد.أصبح الارتفاع الذي تسببه الإنسان في مستوى سطح البحر العالمي الآن أكبر بعشر مرات من الدورات الطبيعية.',
				sphereMapThumbSrc: 'sea_level_thumbnail.png',
				related: ['sea_level']
			}
		]
	},
	{
		value: 'تغير ثاني اكسيد الكربون التاريخي',
		title: 'رسم بياني',
		type: 'static',
		shortDescription: 'يوضح هذا الرسم البياني الوفرة العالمية لثاني أكسيد الكربون على مدار الـ 800000 سنة الماضية ، وكيف تغير أكثر من أكثر من 150 عامًا في كل ذلك الوقت.',
		sphereMapThumbSrc: 'co2_graph_thumbnail.png',
		datasetGroups: [
			{
				title: 'تغير ثاني اكسيد الكربون التاريخي',
				src: 'assets/images/graphics/co2-graph-051619.png',
				width: '1002px',
				height: '626px',
				type: 'static',
				dropDownTitle: 'رسم بياني',
				description: 'تُظهر هذه الصورة رسمًا بيانيًا مع مرور الوقت على طول المحور السيني الذي يتراوح من 800000 عام إلى ثاني أكسيد الكربون في اليوم الحاضر والغلاف الجوي على المحور ص الذي يتراوح بين 160 جزءًا لكل مليون إلى 480 جزءًا في المليون.قبل عام 1950 ، تتراوح مستويات ثاني أكسيد الكربون في الغلاف الجوي بين 175 جزءًا لكل مليون و 300 جزء لكل مليون.منذ عام 1950 ، زاد ثاني أكسيد الكربون في الغلاف الجوي بسرعة إلى 417 جزءًا لكل مليون.غالبًا ما يتم وصف هذا الرسم البياني على أنه "عصا الهوكي" مع خط أفقي طويل يتبعه منحنى تصاعدي حاد في أقصى اليمين.',
				sphereMapThumbSrc: 'co2_graph_thumbnail.png',
				related: ['carbon_dioxide']
			}
		]
	}
];

let currentId = 0;

// Assign unique ID's for vital data, groups and datasets.
const VIDEOS_DATA = VIDEOS.map(video => ({
	id: currentId++,
	...video
}));


export default VIDEOS_DATA;
